import { render, staticRenderFns } from "./AccountHolderBankAccountHolds.vue?vue&type=template&id=81a3f35c&scoped=true"
import script from "./AccountHolderBankAccountHolds.vue?vue&type=script&lang=ts"
export * from "./AccountHolderBankAccountHolds.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderBankAccountHolds.vue?vue&type=style&index=0&id=81a3f35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a3f35c",
  null
  
)

export default component.exports